import React, { FC } from 'react';
import { Logo } from 'shared/ui/logo';
import { StyledHeaderContainer } from './styled';

export const Header: FC = () => {
    return (
        <StyledHeaderContainer data-testid="header">
            <Logo />
        </StyledHeaderContainer>
    );
};
